import React from "react";
const GetTime = (props) => {
  if (props.time) {
    const modifiedTime = props.time.replace(/ /g, "T");
    const time = new Date(modifiedTime);
    let hour = (time.getHours() < 10 ? "0" : "") + time.getHours();
    let min = (time.getMinutes() < 10 ? "0" : "") + time.getMinutes();
    // the hour '0' should be '12'
    const ampm = hour < 12 ? "AM" : "PM";
    hour = hour % 12;
    hour = hour ? hour : 12;
    return (
      <span className="time pl-1">
        {hour}:{min} {ampm}
      </span>
    );
  } else if (props.date) {
    const date = new Date(props.date);
    return (
      <span className="time pl-1">
        {`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`}
      </span>
    );
  }
  return null;
};

export default GetTime;



// WEBPACK FOOTER //
// ./src/components/GetTime.js